import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalContent from 'components/base/secure/modals/modal-content';
import ModalHeader from 'components/base/secure/modals/modal-header';
import SaveButton from 'components/form/save-button';
import { withNamespaces } from 'react-i18next';
import { ParentCategory, Subcategory } from 'store/categoryStore';
import { inject, observer } from 'mobx-react';
import InputField from 'components/form/input-field';

@withNamespaces()
@inject('store')
@observer
class EditCategoryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            name: props.category ? props.category.name : '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.dismiss = this.dismiss.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
        });
    }

    dismiss(e) {
        if (!this.state.loading) {
            this.props.onClose(e);
        }
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.state.loading) {
            return;
        }

        this.setState({loading: true});

        const { category, parentCategory } = this.props;
        let promise;

        if (category) {
            // We're editing a category
            promise = category.requestEdit(this.state);
        } else {
            // We're creating something
            if (parentCategory) {
                // Creating a subcategory
                promise = parentCategory.requestAddSubcategory({...this.state, category: parentCategory.id});
            } else {
                // Creating a root category
                promise = this.props.store.categories.requestAddCategory(this.state);
            }
        }

        if (promise) {
            promise
                .then(response => {
                    if (this.props.onSuccess) {
                        this.props.onSuccess(response.data);
                    } else {
                        this.props.onClose(e);
                    }
                })
                .catch(err => this.setState({loading: false}));
        }
    }

    render() {
        const { loading, name } = this.state;
        const { t, category, parentCategory } = this.props;

        let title = 'BUDGET.CATEGORY.EDIT_MODAL.ADD_TITLE';
        if (category && parentCategory) {
            title = 'BUDGET.CATEGORY.EDIT_MODAL.EDIT_SUB_TITLE';
        } else if (category && !parentCategory) {
            title = 'BUDGET.CATEGORY.EDIT_MODAL.EDIT_TITLE';
        } else if (!category && parentCategory) {
            title = 'BUDGET.CATEGORY.EDIT_MODAL.ADD_SUB_TITLE';
        }

        return (
            <ModalContent>
                <ModalHeader
                    title={t(title, {parentCategory: parentCategory ? t(parentCategory.name) : null})}
                    close={this.dismiss}
                />
                <div className="modal-body">
                    <form onSubmit={this.onSubmit}>
                        <InputField
                            name="name"
                            label={t('BUDGET.CATEGORY.NAME')}
                            onChange={this.handleChange}
                            value={name}
                        />

                        <div className="modal-footer">
                            <SaveButton loading={loading} />
                            <button type="button"
                                    className="btn btn-link"
                                    onClick={this.dismiss}
                                    disabled={loading}
                            >
                                {t('COMMON.OR_CANCEL')}
                            </button>
                        </div>
                    </form>
                </div>
            </ModalContent>
        );
    }
}

EditCategoryModal.propTypes = {
    /** Category which is being edited */
    category: PropTypes.oneOfType([
        PropTypes.instanceOf(ParentCategory),
        PropTypes.instanceOf(Subcategory),
    ]),

    /** Parent category to which we're adding a new category */
    parentCategory: PropTypes.instanceOf(ParentCategory),

    /** Function that gets executed on close */
    onClose: PropTypes.func.isRequired,

    /** Function that gets executed on success */
    onSuccess: PropTypes.func,
};

export default EditCategoryModal;


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/modals/edit-category-modal.js